module.exports = __webpack_public_path__ + "img/attachment.4c29facb.svg";